module.exports = __webpack_public_path__ + "img/logo-title.d5faaf4e.png";